/* Tap-to-show tooltips (2026-09-15).
 *
 * The theme's [data-tooltip] bubbles open on hover (critical.css), which a
 * phone never sends. Any element that also carries data-tooltip-tap toggles
 * its bubble on tap (class is-tip); a tap anywhere else, Escape, or a
 * second tap closes it. Used on the rarity pills (LIMITED / HYPER-RARE) so
 * a first-time visitor can find out what the word means on any device.
 */
(() => {
  const OPEN = 'is-tip';
  let open = null;
  const close = () => {
    if (open) open.classList.remove(OPEN);
    open = null;
  };
  document.addEventListener(
    'click',
    (e) => {
      const t = e.target && e.target.closest ? e.target.closest('[data-tooltip-tap]') : null;
      if (!t) {
        close();
        return;
      }
      if (t.tagName === 'A' || t.closest('a')) e.preventDefault(); // a pill inside a card link: show, don't navigate
      if (open === t) {
        close();
        return;
      }
      close();
      t.classList.add(OPEN);
      open = t;
    },
    true
  );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
  window.addEventListener('scroll', close, { passive: true });
})();
